const apiKey = import.meta.env.VITE_GLEAP_API_KEY;

if (apiKey && typeof window !== "undefined") {
  void import("gleap").then(({ default: Gleap }) => {
    Gleap.setUseCookies(false);
    Gleap.initialize(apiKey);
    Gleap.showFeedbackButton(false);
    Gleap.trackEvent("pageView", { page: window.location.pathname || "/" });

    window.addEventListener("hashchange", () => {
      Gleap.getInstance().softReInitialize();
      Gleap.trackEvent("pageView", {
        page: `${window.location.pathname}${window.location.hash}`,
      });
    });

    window.addEventListener("foundtro:test-request-created", (event) => {
      const detail = event instanceof CustomEvent ? event.detail : {};
      Gleap.attachCustomData({
        foundtro_request_id: detail.request_id,
        foundtro_store_domain: detail.store_domain,
        foundtro_source: "foundtro.com",
      });
      Gleap.trackEvent("Foundtro test request created", {
        request_id: detail.request_id,
        store_domain: detail.store_domain,
      });
    });
  });
}
